export const ZIMBABWE_PHONE_HINT =
  'Numbers must start with 263 and be exactly 12 digits (e.g., 263712345678).';

export const ZIMBABWE_PHONE_ERROR =
  'Phone number must start with 263 and be exactly 12 digits (e.g., 263712345678)';

function formatNumericPhone(value: number): string {
  if (!Number.isFinite(value)) return '';
  return value.toFixed(0);
}

/**
 * Strip formatting and convert local 07… numbers to 263… when possible.
 * Returns digits only, or null if there is nothing usable.
 */
export function normalizePhoneNumber(
  value: string | number | null | undefined
): string | null {
  if (value === null || value === undefined) return null;

  let str =
    typeof value === 'number' ? formatNumericPhone(value) : String(value);
  str = str.trim();
  if (!str) return null;

  if (/e\+/i.test(str)) {
    const numeric = Number(str);
    if (!Number.isNaN(numeric)) {
      str = formatNumericPhone(numeric);
    }
  }

  let digitsOnly = str.replace(/[^\d]/g, '');
  if (!digitsOnly) return null;

  if (digitsOnly.length === 10 && digitsOnly.startsWith('0')) {
    digitsOnly = `263${digitsOnly.slice(1)}`;
  }

  return digitsOnly;
}

export function isValidZimbabwePhone(number: string): boolean {
  return /^263\d{9}$/.test(number);
}

export function toValidZimbabwePhone(
  value: string | number | null | undefined
): string | null {
  const normalized = normalizePhoneNumber(value);
  if (!normalized || !isValidZimbabwePhone(normalized)) {
    return null;
  }
  return normalized;
}

export function looksLikePhoneNumber(
  value: string | number | null | undefined
): boolean {
  if (value === null || value === undefined) return false;
  const digits = String(value).replace(/[^\d]/g, '');
  return digits.length >= 7;
}
